import React from 'react';
import { Link } from 'react-router-dom';
import mainLogo from '../../assets/icons/Logo.svg';
import Footer from '../Footer/Footer';
import signCircles from '../../assets/icons/SignCircles.svg';
import '../../Styles/Sign.scss';

interface SignProps {
  children: React.ReactNode;
  resellerLogo?: string;
  resellerName?: string;
  resellerCode?: string;
}

const Sign: React.FC<SignProps> = ({ children, resellerLogo, resellerName, resellerCode }) => {
  return (
    <div className="sign__page">
      <div className="sign__flex">
        <div className="form">{children}</div>
        <div className="sign__img"></div>
      </div>
      <Footer />
    </div>
  );
};

export default Sign;
